import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import Responsive from '@root/core/src/utils/responsive';
import { StyleSheet } from '@root/core/src/utils/styles';

export default function FooterBase({ children }) {
  return (
    <footer
      css={styles.footer}
      data-testid={'footer-base'}
      role={'footer'}
    >
      <div css={styles.container}>
        {children}
      </div>
    </footer>
  );
}

const styles = StyleSheet.create({
  footer: {
    backgroundColor: '#fafafa',
  },
  container: {
    padding: '40px 30px 60px',
    ...Responsive.md({
      maxWidth: 975,
      margin: '0 auto',
    }),
    ...Responsive.lg({
      padding: '80px 30px',
    }),
  },
});

FooterBase.propTypes = {
  children: PropTypes.node,
};
